import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';

// Matéria do próximo bloco pendente do capítulo ativo acessado por último (badge "Missão de hoje").
// `/current` devolve só esse capítulo (sem trilha ativa: 204, sem `data`).
// null = sem trilha ativa, sem pendências ou erro — o chamador esconde o badge.
export default function useNextMission() {
  const client = useClient();
  const [mission, setMission] = useState(null);

  useEffect(() => {
    let mounted = true;
    client
      .fetch('user_learning_paths/current')
      .then(response => {
        if (!mounted) return;
        setMission(response?.data?.['next-block-subject'] || null);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [client]);

  return mission;
}
